import {useEffect} from "react";

export default function useFatalError(props) {
    const {stores = {}, errors = {}} = props;
    const {basketStore = {}} = stores;

    useEffect(() => {
        if (errors?.fatalErrorMessage) {
            basketStore.errorOrderMessage = errors.fatalErrorMessage;
            basketStore.openDialogBasket();
        }
    }, [errors]);
}
